import { createContext, useContext } from 'react';
import type { AuthStore } from '@/stores/AuthStore';

/**
 * Feature-local AuthStore context. The integration lead mounts
 * <AuthStoreProvider store={root.auth}> above the router (providers.tsx) once
 * AuthStore is registered on RootStore; until then tests inject their own
 * store. Kept separate from src/stores/context.tsx (lead-owned) so this
 * feature compiles before RootStore registration lands.
 */
export const AuthStoreContext = createContext<AuthStore | null>(null);

export function useAuthStore(): AuthStore {
  const store = useContext(AuthStoreContext);
  if (!store) {
    throw new Error('AuthStoreProvider is missing above this component (features/auth)');
  }
  return store;
}
